import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { transparentize } from "polished";
import { parseQueryString } from "../../utils/paths";
import { stringify } from "query-string";

import media from "../../utils/media";

const StyledSearchInput = styled.input`
  flex: 1;
  border: none;
  background: none;
  transition: all 0.5s ease;
  direction: ${props => props.theme.scriptDirection || "ltr"};
  font-family: ${props => props.theme.uiFont};
  padding: 0.3em 0.5em;
  font-size: 1.1rem;
  color: ${props => props.theme.primaryText};
  border-radius: 2px;
  transition: all 0.5s;
  width: 400px;
  max-width: calc(100vw - 204px);
  ${media.desktop`
    background: none;
    padding: 0.65rem;
    color: ${props => props.theme.primaryText};
  `} &::placeholder {
    color: ${transparentize(0.6, "#FFFFFF")};
  }
  &:focus {
    outline: none;
  }
`;

class SearchInput extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        bibleId: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired
    }).isRequired
  };

  constructor(props) {
    super(props);
    this.searchInput = React.createRef();
    this.state = {
      query: parseQueryString(this.props.location.search).q || ""
    };
  }

  componentDidMount() {
    if (this.searchInput) {
      this.searchInput.current.focus();
    }
  }

  handleChange = event => {
    this.setState({ query: event.target.value });
  };

  handleSearchSubmit = event => {
    if (event.keyCode === 13) {
      event.preventDefault();
      const { query } = this.state;
      const { bibleId } = this.props.match.params;
      const { history, location } = this.props;
      if (!query) {
        return;
      }
      if (!location.pathname.includes("search")) history.push(location);
      const newQueryString = stringify({
        ...parseQueryString(this.props.location.search),
        q: query,
        embedInit: undefined
      });
      history.replace(`/bible/${bibleId}/search?${newQueryString}`);
    }
  };

  render() {
    return (
      <StyledSearchInput
        ref={this.searchInput}
        value={this.state.query}
        onChange={this.handleChange}
        onKeyDown={this.handleSearchSubmit}
      />
    );
  }
}

export default withRouter(SearchInput);
